module.exports = __webpack_public_path__ + "img/doct_a.0b166f6c.png";